import React from "react";
import {useHeader} from "../../_metronic/layout";
import {useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import Transfers from "../modules/Transfers/TransfersPage";

export function TransfersPage() {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: "transfers-page-title",
    defaultMessage: "Transfers"
  }));
  const subheader = useSubheader();
  subheader.setCustomClassName("subheader-custom-height");
  subheader.setDisplaySubheader(false);

  return <Transfers/>;
}
